import React, { useEffect, useState } from 'react';
import FormField from './FormField';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Stack, Paper, Typography, Divider, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PasswordField from '../fields/PasswordField';


function ChangePasswordForm({
    initialValues,
    onCancel,
    onSubmit,
    isAdminMode,
    loading
}){

const [errors, setErrors] = useState({});


const [formData, setFormData] = useState({
    id: 0,
    username: '',
    userCurrentPassword: '',
    userNewPassword: '',
    userConfirmNewPassword: ''
});

useEffect(() => {
    const userObject = {
        id: initialValues.id,
        username: initialValues.username,
        userCurrentPassword: initialValues?.userCurrentPassword,
        userNewPassword: initialValues?.userNewPassword,
        userConfirmNewPassword: initialValues?.userConfirmNewPassword

    }

    setFormData(userObject);

}, [initialValues]);

const validatePasswordChange = ({
        userCurrentPassword,
        userNewPassword,
        userConfirmNewPassword
    }) => {
        const passwordMinimumLength = 12;
        const newErrors = {};

        if (!isAdminMode && !userCurrentPassword) {
            newErrors.userCurrentPassword = 'Current password is required.';
        }

        if (!userNewPassword) {
            newErrors.userNewPassword = 'New password is required.';
        }            

        if (!userConfirmNewPassword) {
            newErrors.userConfirmNewPassword = 'New password confirmation is required.';
        }            

        if (userNewPassword && userNewPassword.length < passwordMinimumLength) {
            newErrors.userNewPassword = `New password must be at least ${passwordMinimumLength} characters.`;
        }

        //basic check to ensure the password matches the confim password
        if (userNewPassword && userConfirmNewPassword && userNewPassword !== userConfirmNewPassword) {
            newErrors.userConfirmNewPassword = 'New password and confirm password do not match.'
        }

        // basic check to stop users re-using the same password
        // Only if not admin mode.
        if (!isAdminMode && userCurrentPassword && userNewPassword && userCurrentPassword === userNewPassword) {
            newErrors.userNewPassword = 'New password cannot be the same as the old password';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
};

const handleSubmitInternal = (e) => {
    e.preventDefault();
    const userCurrentPassword = formData.userCurrentPassword;
    const userNewPassword = formData.userNewPassword;
    const userConfirmNewPassword = formData.userConfirmNewPassword;

    if (!validatePasswordChange({
        userCurrentPassword,
        userNewPassword,
        userConfirmNewPassword
    })) {
        return;
    }

    if (onSubmit) {
        onSubmit(formData);
    }

}

const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => {
      const next = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      };
    //   updateDirtyFlag(next);
      return next;
    });
  };

return (
  <Box
    sx={{
      minHeight: "auto",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      px: 2,
      pt: 2,
    }}
  >
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: 560,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 3,
      }}
    >
      <Box component="form" onSubmit={handleSubmitInternal}>
        <Stack spacing={2.5}>
          {/* Header */}
          <Stack spacing={0.5}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Update password
            </Typography>

            <Typography variant="body2" color="text.secondary">
              Username:{" "}
              <Box component="span" sx={{ fontWeight: 600 }}>
                {formData.username}
              </Box>
            </Typography>
          </Stack>

          <Divider />

          {/* Fields */}
          <Stack spacing={2}>
            {!isAdminMode && (
              <FormField
                label="Current password"
                required={true}
                error={errors.userCurrentPassword}
              >
                <PasswordField
                  name="userCurrentPassword"
                  value={formData.userCurrentPassword}
                  onChange={handleChange}
                  error={errors.userCurrentPassword}
                  disabled={loading}
                />
              </FormField>
            )}

            <FormField
              label="New password"
              required={true}
              error={errors.userNewPassword}
            >
              <PasswordField
                name="userNewPassword"
                value={formData.userNewPassword}
                onChange={handleChange}
                error={errors.userNewPassword}
                disabled={loading}
              />
            </FormField>

            <FormField
              label="Confirm new password"
              required={true}
              error={errors.userConfirmNewPassword}
            >
              <PasswordField
                name="userConfirmNewPassword"
                value={formData.userConfirmNewPassword}
                onChange={handleChange}
                error={errors.userConfirmNewPassword}
                disabled={loading}
              />
            </FormField>
          </Stack>

          <Divider />

          {/* Actions */}
          <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{ textTransform: "none", px: 3 }}
            >
              Update password
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Paper>
  </Box>
);

}

export default ChangePasswordForm